<template>
  <div class="h-100">
    <div
      v-if="user.credits > settings.getValue(selectedPlan.price)"
      class="h-100 row align-items-center justify-content-center"
    >
      <!-- <div>
        Tus Creditos: {{ user.credits }} Costo Plan:
        {{ selectedPlan.price }} Restante
        {{ Number(user.credits) - Number(selectedPlan.price) }}
      </div>
      <div>
        <button @click="activateAgencyProfile">Aceptar</button>
      </div> -->
      <div class="row my-auto justify-content-center">
        <div class="col-12 col-md-10">
          <div class="row align-items-center">
            <div class="col-5 pl-0">
              <p>Tu saldo</p>
            </div>
            <div class="col-7">
              <h3>{{ settings.addThousands(user.credits) }}</h3>
            </div>
            <div class="col-5 pl-0">
              <p>Costo del plan</p>
            </div>
            <div class="col-7">
              <h3>-{{ settings.addThousands(selectedPlan.price) }}</h3>
            </div>
          </div>
          <div class="row align-items-center border-top">
            <div class="col-5 pl-0">
              <p>Tu nuevo saldo</p>
            </div>
            <div class="col-7">
              <h3>
                {{
                  settings.addThousands(
                    Number(user.credits) -
                      Number(settings.getValue(selectedPlan.price))
                  )
                }}
              </h3>
            </div>
          </div>
        </div>
        <div class="col-10 pt-5">
          <button class="bg-accent" @click="activateAgencyProfile">
            Aceptar
          </button>
        </div>
      </div>
    </div>
    <!-- MAJENO DE A RECARGA PARA AGENCIAS -->
    <div class="mt-5" v-else-if="!selectedPlanRecharge">
      <div class="container">
        <div class="h-100 row align-items-center justify-content-center">
          <div class="row my-auto justify-content-center px-0">
            <div class="col-11">
              <div class="row align-items-center">
                <div class="col-12 text-left">
                  <p><b>Tu saldo no es suficiente</b></p>
                  <p>Por favor selecciona monto de recarga</p>
                </div>
                <div class="col-12">
                  <button
                    class="outlined-grey my-2"
                    v-for="plan in agencyPlans"
                    v-bind:key="plan._id"
                    @click="selectRecharPlan(plan)"
                  >
                    {{ plan.label }}
                  </button>
                </div>
              </div>
            </div>
            <!-- <div class="col-10 pt-5">
              <button class="bg-accent" @click="confirmRecharPlan">
                Elegir medio de pago
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="h-100" v-if="selectedPlanRecharge">
      <!-- PARA ESTA ALTURA YA HEMOS VALIDADO QUE LO QUE INGRESA AL SELECTOR ES VALIDO
      EL payObId para una agencia es el user.id
       -->
      <payment-method-selector
        :selectedPlan="agencyRechargePlan"
        :isRecharge="true"
      />
    </div>

    <!-- end recarga agencias  -->
  </div>
</template>

<script>
import PaymentMethodSelector from "@/components/UI/Plans/PaymentMethodSelector"
import settings from "@/api/settings"
import { mapActions } from "vuex"
export default {
  components: {
    PaymentMethodSelector,
  },
  methods: {
    ...mapActions(["SET_IS_LOADING", "ACTIVATE_PROFILE"]),
    activateAgencyProfile() {
      this.SET_IS_LOADING(true)
      this.ACTIVATE_PROFILE(this.selectedPlan).then(() => {
        this.$router.push("/")
        this.SET_IS_LOADING(false)
      })
    },
    confirmRecharPlan() {
      this.selectedPlanRecharge = true
    },
    selectRecharPlan(plan) {
      this.$emit("rechargeSelected", plan)
      console.log(plan)
      this.agencyRechargePlan = plan
      this.selectedPlanRecharge = true
      this.$router.push({
        query: {
          steps: "payment-method",
          navbarT: `Pagar ${this.settings.addThousands(
            this.agencyRechargePlan.price
          )}`,
        },
      })
    },
  },
  props: ["user", "selectedPlan"],
  data() {
    // plans for Agency
    const symbol = settings.getSymbolCurrency()
    const agencyPlans = [
      {
        price: 200,
        promo_on_credits: 20,
        label: symbol + "200/20% dto en planes",
      },
      {
        price: 300,
        promo_on_credits: 30,
        label: symbol + "300/25% dto en planes",
      },
      {
        price: 400,
        promo_on_credits: 30,
        label: symbol + "400/30% dto en planes",
      },
      {
        price: 500,
        promo_on_credits: 40,
        label: symbol + "500/40% dto en planes",
      },
      {
        price: 750,
        promo_on_credits: 45,
        label: symbol + "750/45% dto en planes",
      },
      {
        price: 1000,
        promo_on_credits: 50,
        label: symbol + "1,000/50% dto en planes",
      },
    ]
    return {
      agencyRechargePlan: {},
      agencyPlans,
      selectedPlanRecharge: false,
      settings,
    }
  },
}
</script>

<style></style>
